export default __webpack_public_path__ + "static/media/veqtor_adn.5bb7dce2.svg";